import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["Locations"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getV2Locations: build.query<
        GetV2LocationsApiResponse,
        GetV2LocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Locations`,
          params: {
            AccountIds: queryArg.accountIds,
          },
        }),
        providesTags: ["Locations"],
      }),
      postV2Locations: build.mutation<
        PostV2LocationsApiResponse,
        PostV2LocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Locations`,
          method: "POST",
          body: queryArg.locationDto,
        }),
        invalidatesTags: ["Locations"],
      }),
      getV2LocationsById: build.query<
        GetV2LocationsByIdApiResponse,
        GetV2LocationsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/v2/Locations/${queryArg.id}` }),
        providesTags: ["Locations"],
      }),
      putV2LocationsById: build.mutation<
        PutV2LocationsByIdApiResponse,
        PutV2LocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Locations/${queryArg.id}`,
          method: "PUT",
          body: queryArg.baseLocationDto,
        }),
        invalidatesTags: ["Locations"],
      }),
      deleteV2LocationsById: build.mutation<
        DeleteV2LocationsByIdApiResponse,
        DeleteV2LocationsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Locations/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Locations"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetV2LocationsApiResponse = /** status 200 OK */ LocationDto[];
export type GetV2LocationsApiArg = {
  accountIds?: number[];
};
export type PostV2LocationsApiResponse = /** status 201 Created */ LocationDto;
export type PostV2LocationsApiArg = {
  locationDto: LocationDto;
};
export type GetV2LocationsByIdApiResponse = /** status 200 OK */ LocationDto;
export type GetV2LocationsByIdApiArg = {
  id: number;
};
export type PutV2LocationsByIdApiResponse = unknown;
export type PutV2LocationsByIdApiArg = {
  id: number;
  baseLocationDto: BaseLocationDto;
};
export type DeleteV2LocationsByIdApiResponse = unknown;
export type DeleteV2LocationsByIdApiArg = {
  id: number;
};
export type EnergyPriceZone = "DK1" | "DK2";
export type LocationDto = {
  displayName?: string | null;
  street?: string | null;
  houseNumber?: string | null;
  floor?: string | null;
  door?: string | null;
  zipCode?: string | null;
  city?: string | null;
  country?: string | null;
  latitude?: number;
  longitude?: number;
  coordinateAccuracyMeters?: string | null;
  coordinateSource?: string | null;
  timezone?: string | null;
  energyPriceZone?: EnergyPriceZone | null;
  municipalityCode?: number | null;
  cadastreKey?: string | null;
  locationId?: number;
  accountId?: number;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type BaseLocationDto = {
  displayName?: string | null;
  street?: string | null;
  houseNumber?: string | null;
  floor?: string | null;
  door?: string | null;
  zipCode?: string | null;
  city?: string | null;
  country?: string | null;
  latitude?: number;
  longitude?: number;
  coordinateAccuracyMeters?: string | null;
  coordinateSource?: string | null;
  timezone?: string | null;
  energyPriceZone?: EnergyPriceZone | null;
  municipalityCode?: number | null;
  cadastreKey?: string | null;
};
export const {
  useGetV2LocationsQuery,
  usePostV2LocationsMutation,
  useGetV2LocationsByIdQuery,
  usePutV2LocationsByIdMutation,
  useDeleteV2LocationsByIdMutation,
} = injectedRtkApi;
